import { orgFetch } from '~/composables/orgFetch'

export default defineNuxtPlugin(async () => {
    if (process.server) return

    const w: any = window
    const route = useRoute()

    const isAdmin = (path: string) => /^\/[^/]+\/admin(\/|$)/.test(path)

    const loadHubspotScript = (portalId: string) =>
        new Promise<void>((resolve, reject) => {
            if (document.getElementById('hs-script-loader')) return resolve()
            const s = document.createElement('script')
            s.id = 'hs-script-loader'
            s.async = true
            s.defer = true
            s.src = `https://js.hs-scripts.com/${portalId}.js`
            s.onload = () => resolve()
            s.onerror = () => reject(new Error('Failed to load HubSpot script'))
            document.head.appendChild(s)
        })

    const portalId = useRuntimeConfig().public.hubspotPortalId as string

    const init = async () => {
        if (!isAdmin(route.path)) return

        let email: string | undefined
        let token: string | undefined

        try {
            const config = useRuntimeConfig()
            const auat = useCookie('auat')

            const res: any = await orgFetch(`${config.public.apiUrl}/public-pages/hubspot-token`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${auat.value}`,
                    Accept: 'application/json',
                },
            })

            email = res.email
            token = res.token
        } catch {}

        w.hsConversationsSettings = {
            loadImmediately: false,
            ...(email && token ? { identificationEmail: email, identificationToken: token } : {}),
        }

        w.hsConversationsOnReady = w.hsConversationsOnReady || []
        w.hsConversationsOnReady.push(() => {
            w.HubSpotConversations?.widget?.load?.()
            w.HubSpotConversations?.widget?.close?.()
        })

        await loadHubspotScript(portalId)
    }

    await init()

    watch(
        () => route.path,
        async (p) => {
            if (isAdmin(p)) {
                await init()
            } else {
                document.getElementById('hubspot-messages-iframe-container')?.remove()
            }
        }
    )
})